import { Tooltip as BaseTooltip } from 'antd'
import React from 'react'

export function Tooltip(props: React.ComponentProps<typeof BaseTooltip>) {
  return <BaseTooltip {...props} />
}
